import { c as _c } from "react/compiler-runtime";
import { translateInline } from '@/globals/translate/translateInline';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { ReactNode } from 'react';
import { textBlock, textInline, textStyle } from '@/uiPrimitives/typography/text';
import { box } from '@/uiPrimitives/layout/box';
import { olMarker } from '@/uiComposites/list/listItem.css';
import { subgridColumns } from '@/uiPrimitives/layout/pageGrid/subgridColumns';
import { unprintable } from '@/uiPrimitives/base/printable.css';
import { position } from '@/uiPrimitives/layout/position';
import { indentSize } from '@/uiPrimitives/layout/indentSize.definitions';
export const AnsweredQuestionContainer = t0 => {
  const $ = _c(6);
  const {
    children,
    viewTransitionName
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(subgridColumns({
      columnGap: "3 | h1"
    }), box({
      paddingBlock: "3 | h1",
      borderBlockStyle: "solid",
      borderWidth: "1px",
      borderColor: "positiveMuted",
      borderCollapse: "block",
      paddingInline: indentSize
    }), textStyle({
      color: "positiveMuted"
    }), position({
      position: "relative"
    }));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== viewTransitionName) {
    t2 = {
      viewTransitionName
    };
    $[1] = viewTransitionName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <li className={t1} style={t2}>{children}</li>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export const QuestionNumber = () => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classes(textBlock({
      fontWeight: "bold"
    }));
    t1 = translateInline({
      en: "Question",
      nl: "Vraag"
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={t0}>{t1}{" "}<i className={classes(olMarker)} />{":"}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const Answer = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(textBlock({
      textOverflow: "ellipsis"
    }));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className={t1}>{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const NoAnswerInline = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className={classes(textInline({
      fontStyle: "italic"
    }))}>{translateInline({
        nl: "Geen antwoord",
        en: "No answer"
      })}</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const EditButton = t0 => {
  const $ = _c(8);
  const {
    onClick,
    questionTitle
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(unprintable, textBlock({
      color: "positiveBlue",
      textDecorationLine: "underline"
    }));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `Edit question ${questionTitle}`;
  const t3 = `Wijzig vraag ${questionTitle}`;
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = translateInline({
      en: t2,
      nl: t3
    });
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = translateInline({
      en: "Edit",
      nl: "Wijzigen"
    });
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onClick || $[6] !== t4) {
    t6 = <button onClick={onClick} type="button" className={t1} aria-label={t4}>{t5}</button>;
    $[5] = onClick;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};